import { BORDER_RADIUS, COLORS, DEVICE_TYPE, SIZE } from "constants/variables";
import styled from "styled-components";

export const PartnerDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SIZE.max24};
  width: 100%;
  padding: ${SIZE.max40};
  max-height: 90vh;
  min-height: 50vh;
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column;
    height: 100%;
    max-height: 90vh;
    overflow-y: scroll;
  }
`;

export const PartnerDetailsIconContainer = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 452px;
  background-color: ${COLORS.Gunmetal};
  display: flex;
  justify-content: center;
  border-radius: ${BORDER_RADIUS.radius32};
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-width: 100%;
  }
`;

export const PartnerDetailsTextContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 704px;
  background-color: ${COLORS.Gunmetal};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max40} 0 ${SIZE.max40} ${SIZE.max40};
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    max-height: fit-content;
  }
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-right: ${SIZE.max40};
`;

export const ThirdColumnContainer = styled.div`
  border-radius: ${BORDER_RADIUS.radius32};
  display: flex;
  min-width: 324px;
  flex-direction: column;
  gap: ${SIZE.max24};
`;

export const SmallContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.Gunmetal};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max40};
  position: relative;
  gap: 8px;
`;

export const SmallAgendaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.Yellow};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max40};
  position: relative;
  gap: 8px;
  cursor: pointer;
`;

export const AgendaTextWrapper = styled.div`
  width: 102px;
`;

export const DownloadButtonContainer = styled.div`
  position: absolute;
  right: 24px;
  bottom: 24px;
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    bottom: 14px;
  }
`;

export const Image = styled.img`
  width: 188.95px;
  height: 110px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  @media screen and (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: auto;
    height: ${SIZE.max110};
    bottom: 10px;
    right: 20px;
  }
`;
